import {
  isEmpty,
  convertBase64ToFile,
  getFirebaseUrlFromFile,
  fetchAndConvertToBase64,
  DEFAULT_UPLOAD_FOLDER
} from '../../../../helpers/common';

export async function processDescription(
  rawDescription: string,
  folderName = DEFAULT_UPLOAD_FOLDER
): Promise<string> {
  let descriptionData = rawDescription || '';
  const pattern = /(^<p><br><\/p>\s*)|(<p><br><\/p>\s*$)/;
  if (!isEmpty(descriptionData)) {
    while (pattern.test(descriptionData)) {
      descriptionData = descriptionData.replace(pattern, '');
    }
    if (descriptionData.match(/<br\s*>\s*<\/p>$/)) {
      descriptionData = descriptionData.replace(/<br\s*>\s*<\/p>$/, '</p>');
    }
  }

  const tempElement = document.createElement('div');
  tempElement.innerHTML = descriptionData || '';
  const linkElements = tempElement.querySelectorAll('div[src]');

  // Process each element sequentially to avoid race conditions on shared descriptionData
  for (const el of Array.from(linkElements)) {
    const srcLink = el?.getAttribute('src');
    if (!srcLink || isEmpty(srcLink)) continue;

    if (srcLink.startsWith('https://asana')) {
      const base64Url = await fetchAndConvertToBase64(srcLink);
      const fileData = await convertBase64ToFile(base64Url);
      const fileUrl = await getFirebaseUrlFromFile({ file: fileData }, folderName);
      if (fileUrl) {
        const asanaUrlRegex = /https:\/\/asana[^\s"'<>)]*/g;
        descriptionData = descriptionData.replace(asanaUrlRegex, fileUrl);
      }
    } else if (
      !srcLink.startsWith('https://firebasestorage') &&
      !srcLink.startsWith('https://figma') &&
      !srcLink.startsWith('/static') &&
      !srcLink.startsWith('https://')
    ) {
      try {
        const fileData = await convertBase64ToFile(srcLink);
        const fileUrl = await getFirebaseUrlFromFile({ file: fileData }, folderName);
        if (fileUrl) {
          descriptionData = descriptionData.replace(srcLink, fileUrl);
        }
      } catch (error) {
        console.error('Error processing image URL', error);
      }
    }
  }

  return descriptionData;
}
